import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-4 md:p-6 bg-gray-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl md:text-2xl lg:text-3xl font-extrabold mb-2" }, "Like what you see?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm md:text-base lg:text-lg max-w-2xl" }, "Please click \"I'm interested\" below and you can request more information or submit a soft quote. Or click \"this isn't a fit\" and tell us what you didn't like here and what you'd prefer to see going forward. We take $1B per week in deal flow and want to optimize your experience.", -1)
const _hoisted_4 = { class: "flex items-center justify-start mt-4 md:mt-6" }
const _hoisted_5 = { class: "text-xl md:text-2xl lg:text-3xl font-extrabold mb-3 md:mb-6" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "ml-2 md:ml-4" }
const _hoisted_8 = { class: "text-sm md:text-base font-medium md:leading-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs md:text-sm font-medium md:leading-6 text-gray-600" }, "Senior Advisor @ Janover", -1)
const _hoisted_10 = { class: "sm:flex items-center mt-2" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm lg:text-xl lg:leading-8 font-normal max-w-xl mt-3 md:mt-5" }, " We will be back in touch with you shortly to help get you what you need to put a quote together. ", -1)
const _hoisted_14 = { class: "flex items-center justify-start mt-3 md:mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quote_form = _resolveComponent("quote-form")!
  const _component_quote_reject = _resolveComponent("quote-reject")!
  const _component_quote_more_info = _resolveComponent("quote-more-info")!
  const _component_SoftQuote = _resolveComponent("SoftQuote")!
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")!
  const _component_MailIcon = _resolveComponent("MailIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state === 'default')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "text-xs lg:text-base text-white bg-green-600 hover:bg-green-800 rounded-md mr-2 lg:mr-4 py-2 px-4 focus:outline-none border-none",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state = 'quote')),
              id: "quote-submit"
            }, " Submit a soft quote "),
            _createElementVNode("button", {
              type: "button",
              class: "text-xs lg:text-base text-sky bg-indigo-100 hover:bg-sky hover:text-white rounded-md mr-2 lg:mr-4 py-2 px-4 focus:outline-none border-none",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state = 'more-info')),
              id: "quote-request"
            }, " Request information "),
            _createElementVNode("button", {
              type: "button",
              class: "text-xs lg:text-base text-white bg-red-500 hover:bg-red-600 hover:text-white rounded-md mr-2 lg:mr-4 py-2 px-4 focus:outline-none border-none",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state = 'reject')),
              id: "quote-reject"
            }, " This isn't a fit ")
          ])
        ], 64))
      : (_ctx.state == 'quote')
        ? (_openBlock(), _createBlock(_component_quote_form, {
            key: 1,
            om: _ctx.om,
            onSubmitted: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state = 'advisor'))
          }, null, 8, ["om"]))
        : (_ctx.state == 'reject')
          ? (_openBlock(), _createBlock(_component_quote_reject, {
              key: 2,
              om: _ctx.om,
              onSubmitted: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleReject()))
            }, null, 8, ["om"]))
          : (_ctx.state == 'more-info')
            ? (_openBlock(), _createBlock(_component_quote_more_info, {
                key: 3,
                om: _ctx.om,
                onSubmitted: _cache[5] || (_cache[5] = ($event: any) => (_ctx.state = 'advisor'))
              }, null, 8, ["om"]))
            : (_ctx.state === 'advisor')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.distribution.status == 'NotInterested' ? "Thank you for your feedback!" : "Thank you for your interest!"), 1),
                  (_ctx.distribution.softQuote)
                    ? (_openBlock(), _createBlock(_component_SoftQuote, {
                        key: 0,
                        quote: _ctx.distribution.softQuote,
                        class: "mb-6"
                      }, null, 8, ["quote"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "w-20 h-20 md:w-24 md:h-24 rounded-md flex-shrink-0",
                      style: _normalizeStyle({ 'background-image': `url(${_ctx.photo})`, 'background-size': 'cover' })
                    }, null, 4),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.om.advisor.name), 1),
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("a", {
                          href: `tel:${_ctx.om.advisor.phone}`,
                          class: "bg-white inline-flex text-xs items-center border rounded-md py-1.5 px-2.5 mr-2 pointer-events-none hidden"
                        }, [
                          _createVNode(_component_PhoneIcon, { class: "w-3 h-3 mr-2" }),
                          _createTextVNode(" Schedule a call ")
                        ], 8, _hoisted_11),
                        _createElementVNode("a", {
                          href: `mailto:${_ctx.om.advisor.email}`,
                          class: "mt-1 sm:mt-0 bg-white inline-flex text-xs items-center border rounded-md py-1.5 px-2.5"
                        }, [
                          _createVNode(_component_MailIcon, { class: "w-3 h-3 mr-2" }),
                          _createTextVNode(" Email ")
                        ], 8, _hoisted_12)
                      ])
                    ])
                  ]),
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: "/",
                      class: "text-xs md:text-sm lg:text-base text-white bg-green-600 hover:bg-green-800 rounded-md mr-4 py-2 px-4 focus:outline-none border-none"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" See more deals ")
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
              : _createCommentVNode("", true)
  ]))
}